import doc                                      from '@widesk-core/decorators/doc';
import model                                    from '@widesk-core/decorators/model';
import NetworkServiceModel                      from '@/models/NetworkServiceModel';
import ContactModel                             from './ContactModel';
import RelationRequestStatusModel               from './RelationRequestStatusModel';
import OwnerUserModel                           from './OwnerUserModel';
import RelationRequestModel                     from './RelationRequestModel';
import RelationRequestTargetResponseStatusModel from './RelationRequestTargetResponseStatusModel';

@model.urnResource('relation_request_target_response')
@doc.path('/relation_request_target_responses/{?id}')
export default class RelationRequestTargetResponseModel extends NetworkServiceModel {
	private declare _tsFilters: {
		"id": id;
		"contact": id;
		"ownerUser": id;
		"relationRequest": id;
		"relationRequestTargetResponseStatus": id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(RelationRequestModel) declare relationRequest: RelationRequestModel;
	@doc.model(RelationRequestStatusModel) declare relationRequestTargetResponseStatus: RelationRequestTargetResponseStatusModel;
	@doc.model(ContactModel) declare contact: ContactModel;
	@doc.model(OwnerUserModel) declare target: OwnerUserModel;
	@doc.string declare requesterLabel: string;
	@doc.string declare requesterPhotoUrl: string;

}